// import * as Sentry from "@sentry/capacitor";
import * as SentryVue from "@sentry/vue";
import { App } from "@capacitor/app";
import { Device } from "@capacitor/device";
import { CapacitorUpdater } from "@capgo/capacitor-updater";
import router from "@/router";

const useVueReport = true;

export const initSentry = async (app: any) => {
  if (useVueReport) {
    SentryVue.init({
      app,
      dsn: "https://7e1475367f64e3212c4a2c6b33ef3430@o4508520892268544.ingest.us.sentry.io/4508974447067136",
      integrations: [
        SentryVue.browserTracingIntegration({ router }),
        SentryVue.replayIntegration({
          // maskAllText: false,
          // blockAllMedia: true,
        }),
        // for issue: https://github.com/getsentry/sentry-capacitor/issues/759
        SentryVue.breadcrumbsIntegration({
          console: true,
          dom: true,
          fetch: true,
          history: true,
          xhr: false,
        }),
      ],
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
      tracePropagationTargets: [
        "localhost",
        "192.168.13.226",
        /^https:\/\/yourserver\.io\/api/,
      ],
      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  } else {
    //   @sentry/capacitor 生成的 native 详情较多报错信息不明显
    // Sentry.init(
    //   {
    //     app,
    //     // debug: true,
    //     dsn: "https://aa56f1d9e6f77b47063a67b5b5ae3c21@o4508520892268544.ingest.us.sentry.io/4508521475276800",
    //     // Set your release version, such as "getsentry@1.0.0"
    //     release: "域控UI@<1.0.3>",
    //     // Set your dist version, such as "1"
    //     dist: "3",
    //     integrations: [
    //       // Registers and configures the Tracing integration,
    //       // which automatically instruments your application to monitor its
    //       // performance, including custom Angular routing instrumentation
    //       Sentry.browserTracingIntegration(),
    //       // Registers the Replay integration,
    //       // which automatically captures Session Replays
    //       Sentry.replayIntegration(),
    //       // for issue: https://github.com/getsentry/sentry-capacitor/issues/759
    //       // Sentry.breadcrumbsIntegration({
    //       //   console: true,
    //       //   dom: true,
    //       //   fetch: true,
    //       //   history: true,
    //       //   xhr: false,
    //       // }),
    //     ],

    //     // Set tracesSampleRate to 1.0 to capture 100%
    //     // of transactions for tracing.
    //     // We recommend adjusting this value in production
    //     // Learn more at
    //     // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    //     tracesSampleRate: 1.0,

    //     // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    //     tracePropagationTargets: [
    //       "localhost",
    //       "192.168.13.226",
    //       /^https:\/\/yourserver\.io\/api/,
    //     ],
    //     // Capture Replay for 10% of all sessions,
    //     // plus for 100% of sessions with an error
    //     // Learn more at
    //     // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    //     replaysSessionSampleRate: 0.1,
    //     replaysOnErrorSampleRate: 1.0,
    //   },
    //   // Forward the init method from @sentry/angular
    //   SentryVue.init
    // );
  }
  const deviceInfo = await Device.getInfo();
  const deviceId = await Device.getId();
  const appInfo = await App.getInfo();
  const { bundle } = await CapacitorUpdater.current();
  // 设置 Sentry extras
  SentryVue.setExtras({
    deviceModel: deviceInfo.model,
    devicePlatform: deviceInfo.platform,
    deviceManufacturer: deviceInfo.manufacturer,
    deviceId: deviceId.identifier,
    appVersion: appInfo.version,
    appBuild: appInfo.build,
    appName: appInfo.name,
    appId: appInfo.id,
    webVersion: bundle.version,
    // 如果你有其他方式获取 VIN，可以在这里添加
    // vin: yourVinValue
  });
};
